// 第三方库
import { makeAutoObservable, runInAction } from 'mobx';

// 内部模块 - 工具
import { logger } from '@/utils/logger';

// 内部模块 - Store
import { accountStore } from './AccountStore';

/**
 * Token 调试 Store
 * 单一职责：管理 Token 调试面板的状态和操作
 */
class TokenDebugStore {
  visible = false;
  refreshing = false;
  lastMessage = null;

  constructor() {
    makeAutoObservable(this);
  }

  // 显示调试面板
  show() {
    runInAction(() => {
      this.visible = true;
      this.lastMessage = null;
    });
  }

  // 隐藏调试面板
  hide() {
    runInAction(() => {
      this.visible = false;
      this.lastMessage = null;
    });
  }

  // 设置消息
  setMessage(type, content) {
    runInAction(() => {
      this.lastMessage = { type, content };
    });
  }

  // 清除消息
  clearMessage() {
    runInAction(() => {
      this.lastMessage = null;
    });
  }

  // 刷新 Token
  async refreshToken() {
    runInAction(() => {
      this.refreshing = true;
      this.lastMessage = null;
    });

    try {
      const success = await accountStore.refreshToken();
      if (success) {
        this.setMessage('success', 'Token 刷新成功！');
        logger.debug('[TokenDebugStore] Token 刷新成功');
      } else {
        this.setMessage('error', 'Token 刷新失败：响应中未找到 token');
        logger.warn('[TokenDebugStore] Token 刷新失败');
      }
    } catch (error) {
      const errorMsg = `Token 刷新出错: ${error.message}`;
      this.setMessage('error', errorMsg);
      logger.error('[TokenDebugStore] Token 刷新出错:', error);
    } finally {
      runInAction(() => {
        this.refreshing = false;
      });
    }
  }

  // 格式化 Token 显示
  formatToken(token) {
    if (!token) return '无';
    return token.length > 50 ? `${token.substring(0, 50)}...` : token;
  }

  // 解析 Token 信息
  parseTokenInfo(token) {
    if (!token) return null;
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return {
        id: payload.id,
        name: payload.name,
        tenantId: payload.tenantId,
        isAdmin: payload.isAdmin,
        iat: new Date(payload.iat * 1000).toLocaleString(),
        exp: new Date(payload.exp * 1000).toLocaleString(),
        remainingTime: Math.max(0, Math.floor((payload.exp * 1000 - Date.now()) / 1000 / 60)),
      };
    } catch {
      return null;
    }
  }
}

export const tokenDebugStore = new TokenDebugStore();
